import { Marked, type Tokens } from 'marked';

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

// The answer can quote document content, so it must never inject markup or
// URLs: raw HTML is shown as text, links and images keep only their text.
// marked already escapes plain text and code itself.
const marked = new Marked({
  async: false,
  breaks: true,
  renderer: {
    html(token: Tokens.HTML | Tokens.Tag) {
      return escapeHtml(token.text);
    },
    link(token: Tokens.Link) {
      return this.parser.parseInline(token.tokens);
    },
    image(token: Tokens.Image) {
      return escapeHtml(token.text);
    },
  },
});

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
}

/** Markdown answer of the assistant -> safe HTML for `HTMLDisplay`. */
export function answerToHtml(answer: string): string {
  return (marked.parse(answer) as string).trim();
}
